import { ReactNode } from 'react'
import { useTonAddress } from '@tonconnect/ui-react'
import { getAuth } from 'firebase/auth'
import { useAuthState } from 'react-firebase-hooks/auth'
import { firebaseApp } from '@/helpers/firebase'
import { Wallet } from '@/screens/Wallet'

interface ProtectedRouteProps {
  children: ReactNode
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const walletAddress = useTonAddress()
  const [user, loading] = useAuthState(getAuth(firebaseApp))

  if (!walletAddress || !user) {
    return <Wallet />
  }

  if (loading) {
    return (
      <div className="cards-container">
        <div className="loading-state">
          <div className="loading-spinner"></div>
          <p>Loading your cards...</p>
        </div>
      </div>
    )
  }

  return <>{children}</>
}
